var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('PairSpin',{attrs:{"show":_vm.isShowPairSpin}}),_vm._v(" "),_c('Content',{staticClass:"cust-content"},[_c('Row',{staticClass:"content-table-wrapper"},[_c('Row',[_c('Table',{attrs:{"columns":_vm.tableColumns,"data":_vm.recordHistDataAuditList,"loading":_vm.isListLoading,"stripe":"","border":""}})],1)],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-c8986e94","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/audit/RecordHistDataAuditCard.vue
// module id = null
// module chunks = 